import { __read, __spread } from "tslib";
import { toParams, toQuery } from './url';
var PopupWindow = /** @class */ (function () {
    function PopupWindow(id, url, popupOptions, otherOptions) {
        if (popupOptions === void 0) { popupOptions = {}; }
        if (otherOptions === void 0) { otherOptions = {}; }
        this.id = id;
        this.url = url;
        this.popupOptions = popupOptions;
        this.otherOptions = otherOptions;
        this.locationKey = otherOptions.locationKey;
    }
    PopupWindow.prototype.open = function () {
        this.window = window.open(this.url, this.id, toQuery(this.popupOptions, ','));
    };
    PopupWindow.prototype.close = function () {
        this.cancel();
        this.window.close();
    };
    PopupWindow.prototype.poll = function () {
        var _this = this;
        this.promise = new Promise(function (resolve, reject) {
            _this.intervalId = window.setInterval(function () {
                try {
                    var popup = _this.window;
                    if (!popup || popup.closed !== false) {
                        _this.close();
                        reject(new Error('The popup was closed for an unexpected reason'));
                        return;
                    }
                    if (popup.location.href === _this.url || popup.location.pathname === 'blank') {
                        // location unchanged, still polling
                        return;
                    }
                    if (!['search', 'hash'].includes(_this.locationKey)) {
                        reject(new Error("Cannot get data from location." + _this.locationKey + ", check the responseType prop"));
                        _this.close();
                        return;
                    }
                    var locationValue = popup.location[_this.locationKey];
                    var params = toParams(locationValue);
                    resolve(params);
                    _this.close();
                }
                catch (error) {
                    /*
                     * Ignore DOMException: Blocked a frame with origin from accessing a
                     * cross-origin frame.
                     */
                }
            }, 500);
        });
    };
    PopupWindow.prototype.cancel = function () {
        if (this.intervalId) {
            window.clearInterval(this.intervalId);
            this.intervalId = undefined;
        }
    };
    PopupWindow.prototype.then = function () {
        var _a;
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        return (_a = this.promise) === null || _a === void 0 ? void 0 : _a.then.apply(_a, __spread(args));
    };
    PopupWindow.prototype.catch = function () {
        var _a;
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        return (_a = this.promise) === null || _a === void 0 ? void 0 : _a.catch.apply(_a, __spread(args));
    };
    PopupWindow.open = function (id, url, popupOptions, otherOptions) {
        if (popupOptions === void 0) { popupOptions = {}; }
        if (otherOptions === void 0) { otherOptions = {}; }
        var popup = new this(id, url, popupOptions, otherOptions);
        popup.open();
        popup.poll();
        return popup;
    };
    return PopupWindow;
}());
export default PopupWindow;
//# sourceMappingURL=PopupWindow.js.map